export default async () => {
  return {
    // @ts-ignore
    'contracts/SampleERC20.sol': (await import('raw-loader!./contracts/SampleERC20.sol')).default,
    // @ts-ignore
    'scripts/deploy_with_ethers.ts': (await import('!!raw-loader!./scripts/deploy_with_ethers.ts')).default,
    // @ts-ignore
    'scripts/ethers-lib.ts': (await import('!!raw-loader!./scripts/ethers-lib.ts')).default,
    // @ts-ignore
    'tests/SampleERC20_test.sol': (await import('raw-loader!./tests/SampleERC20_test.sol')).default,
    // @ts-ignore
    '.prettierrc.json': (await import('raw-loader!./.prettierrc')).default,
    // @ts-ignore
    'remix.config.json': (await import('raw-loader!./remix.config')).default
  }
}